import { action, Action } from "easy-peasy";

export interface IChatModel {
  channels: any;
  setChannels: Action<any, any>;
  allChannels: any;
  setAllChannels: Action<any,any>;
}

const chat: IChatModel = {
  channels: [],
  setChannels: action((state: any, channels: any) => {
    state.channels = channels;
  }),
  allChannels: [],
  setAllChannels: action((state: any, allChannels: any) => {
    state.allChannels = allChannels;
  }),
  
};

export default chat;
